import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, RouteReuseStrategy, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EncryptionInterceptor } from './core/encryption-interceptor/encryption.interceptor';
import { provideToastr } from 'ngx-toastr';
import { SummaryMapReuseStrategy } from './core/route-reuse/summary-map-reuse-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withRouterConfig({
      onSameUrlNavigation: 'reload'
    })),
    provideHttpClient(withInterceptors([EncryptionInterceptor])),
    provideToastr(),
    { provide: RouteReuseStrategy, useClass: SummaryMapReuseStrategy },
  ]
};
